import { render, staticRenderFns } from "./PopupCreateTask.vue?vue&type=template&id=58021ed1"
import script from "./PopupCreateTask.vue?vue&type=script&lang=ts"
export * from "./PopupCreateTask.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports